<script>
  import { SPRITESHEET_URL } from '../../utils/constants';
  
  let { label = '', type = 'default', skeletonLength = Math.floor(Math.random() * 4) } = $props();
</script>

<div
  class="w-full my-4 flex items-stretch min-h-18 lg:min-h-22 rounded-lg shadow-y-sm border
  border-gray-light-silver overflow-hidden"
>
  <div class="flex grow justify-center flex-col p-4 py-3 lg:p-5 border-r border-gray-light-silver">
    {#if type === 'hd'}
      <div class="flex items-center mb-1">
        <svg class="w-6 h-6 lg:w-8 lg:h-8 stroke-current text-gray-warm" role="presentation">
          <use xlink:href="{SPRITESHEET_URL}#mail-delivery" />
        </svg>
        <span class="ml-2 text-xs lg:text-base text-gray-warm">{label}</span>
      </div>
    {/if}
    <div
      class="w-full h-5 lg:h-7 skeleton-gradient animated-skeleton"
      class:max-w-36={skeletonLength === 0}
      class:max-w-46={skeletonLength === 1}
      class:max-w-22={skeletonLength === 2}
      class:max-w-28={skeletonLength === 3}
      class:sm:max-w-65={skeletonLength === 0}
      class:sm:max-w-75={skeletonLength === 1}
      class:sm:max-w-46={skeletonLength === 2}
      class:sm:max-w-56={skeletonLength === 3}
    ></div>
  </div>
  <div class="flex grow-0 flex-row w-30 sm:w-36 md:w-46 lg:w-53 min-h-full items-center px-1 py-4">
    <div class="flex-auto flex flex-col items-center justify-center pl-1 sm:pl-3 px-2 lg:pr-0">
      <div class="w-20 h-4 lg:w-24 lg:h-6 skeleton-gradient animated-skeleton"></div>
      {#if type === 'unc'}
        <div class="w-12 lg:w-20 h-2 lg:h-4 mt-2 skeleton-gradient animated-skeleton animation-delay-75"></div>
      {/if}
    </div>
    <svg class="flex-none w-4 h-4 lg:w-6 lg:h-6 fill-current text-gray-warm" role="presentation">
      <use xlink:href="{SPRITESHEET_URL}#chevron-right" />
    </svg>
  </div>
</div>
